module.exports = __webpack_public_path__ + "img/GIF_CANAL-NB.6a500d79.gif";